import { IncomeDocument } from '@/types/income'
import { ExpenseDocument } from '@/types/expense'

import api from './config'

import { fileToBase64 } from '@/utils/file'

const documentsAPI = {
  analyzeIncome: async (file: File) => {
    const base64 = await fileToBase64(file)

    const response = await api.post<IncomeDocument>(
      '/documents/analyze_income',
      {
        document: {
          file: base64,
          filename: file.name,
          content_type: file.type
        }
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    return response.data
  },
  analyzeExpense: async (file: File) => {
    const base64 = await fileToBase64(file)

    const response = await api.post<ExpenseDocument>(
      '/documents/analyze_expense',
      {
        document: {
          file: base64,
          filename: file.name,
          content_type: file.type
        }
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    return response.data
  },
}

export default documentsAPI